export let hres4axColumns = () => {
  let indexColumns = [
    {
      key: 'desc_linef',
      name: '',
      labelCodapp: 'HRES4AXC1',
      labelIndex: '20',
      style: 'min-width: 200px;'
    }, {
      key: 'dteeffec',
      name: '',
      labelCodapp: 'HRES4AXC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'dteuse',
      name: '',
      labelCodapp: 'HRES4AXC1',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES4AXC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;'
    }
  ]

  let popup1Tab1Columns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'numlvl',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'dteempmt',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'desc_typemp',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }
  ]

  let popup1Tab2Columns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '210',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '220',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '230',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '240',
      style: 'min-width: 200px;'
    }, {
      key: 'numlvl',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '250',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'dteempmt',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '260',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }
  ]

  let popup1Tab3Columns = [
    {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '310',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '320',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '330',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '340',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '350',
      style: 'min-width: 200px;'
    }, {
      key: 'numlvl',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '360',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'dteempmt',
      name: '',
      labelCodapp: 'HRES4AXC4',
      labelIndex: '370',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }
  ]

  let popup2Tab2Columns = [
    {
      key: 'kpino',
      name: '',
      labelCodapp: 'STDPOSP2',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'kpiitem',
      name: '',
      labelCodapp: 'STDPOSP2',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'target',
      name: '',
      labelCodapp: 'STDPOSP2',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }
  ]

  let popup2Tab3Columns = [
    {
      key: 'codtencyd',
      name: '',
      labelCodapp: 'STDPOSP3',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codtencyd',
      name: '',
      labelCodapp: 'STDPOSP3',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'codskill',
      name: '',
      labelCodapp: 'STDPOSP3',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codskill',
      name: '',
      labelCodapp: 'STDPOSP3',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'fscore',
      name: '',
      labelCodapp: 'STDPOSP3',
      labelIndex: '80',
      class: 'align-right',
      style: 'min-width: 100px;'
    }, {
      key: 'score',
      name: '',
      labelCodapp: 'STDPOSP3',
      labelIndex: '90',
      class: 'align-right',
      style: 'min-width: 100px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      popup1Tab1Table: popup1Tab1Columns,
      popup1Tab2Table: popup1Tab2Columns,
      popup1Tab3Table: popup1Tab3Columns,
      popup2Tab2Table: popup2Tab2Columns,
      popup2Tab3Table: popup2Tab3Columns
    },
    th: {
      index: indexColumns,
      popup1Tab1Table: popup1Tab1Columns,
      popup1Tab2Table: popup1Tab2Columns,
      popup1Tab3Table: popup1Tab3Columns,
      popup2Tab2Table: popup2Tab2Columns,
      popup2Tab3Table: popup2Tab3Columns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres4ax.js